import { useAuth } from "@/contexts/AuthContext";
import { submitSurvey } from "@/services/generatedAPIs";
import { SurveyItem, UserInfoResponseRole } from "@/services/generatedAPIs.schemas";
import { useEffect, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { toast } from "sonner";

function Survey4({
    t,
    onSuccess,
    ...props
}: WithTranslation & { onSuccess?: () => void }) {
    const { getCurrentUser } = useAuth();

    const questions = [
        { id: 1, text: "1. 我一定要比別的同學做的更好。" }, 
        { id: 2, text: "2. 對我來說，在數學上與其他同學相比表現地更好，是重要的。" }, 
        { id: 3, text: "3. 在數學上，我的目標是要取得比大部分同學更好的成績。。" },
        { id: 4, text: "4. 我擔心，自己可能沒有掌握這數學課上應學到的全部內容。" },
        { id: 5, text: "5. 有時候，我擔心自己無法徹底地理解這數學課的內容。" },
        { id: 6, text: "6. 我經常擔心，我可能沒有學到這數學課的全部內容。" },
        { id: 7, text: "7. 我希望在這數學課中，盡可能學到最多的知識。" },
        { id: 8, text: "8. 對我來說，盡量透徹地理解數學這個科目的內容是重要的。" },
        { id: 9, text: "9. 我非常希望，能夠完全掌握數學這個科目中應該學到的內容。" },
        { id: 10, text: "10. 我只是想避免在數學這個科目中表現不好。" },
        { id: 11, text: "11. 我的目標，是在數學這個科目上成績不要太差。" },
        { id: 12, text: "12. 我對數學科表現不佳的擔憂，常常成為我的動力。" },
        { id: 13,  text: "13. 我在數學中學到了很多有趣的東西"},
        { id: 14,  text: "14. 我喜歡解數學題。"},
        { id: 15,  text: "15. 我期待數學課。"},
        { id: 16,  text: "16. 努力學好學校數學很值得，因為這對我以後想從事的工作有幫助。"},
        { id: 17,  text: "17. 數學對我來說是一門重要的科目，因為我日後想學習的內容需要它。"},
        { id: 18,  text: "18. 我在學校數學課上學到的很多東西都有助於我將來找工作。"}
    ];

    const [ answers ] = useState<SurveyItem[]>(new Array(questions.length));
    const [ startTime, setStartTime ] = useState<Date>();

    useEffect(() => {
        setStartTime(new Date());
    }, []);

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6">
                <div className="bg-white/80 bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 shadow-xl w-full max-w-3xl border border-white/50 relative max-h-[90vh] overflow-y-auto">
                    <h2 className="text-2xl font-bold text-slate-700 text-center mb-4">Hi, 同學！為了更好的學習體驗，請填寫以下問卷。填寫完成後即可開始使用本平台。</h2>
                     <h4 className=" font-bold text-slate-700 text-center mb-4">你在多大程度上同意以下關於自己的描述：</h4>
                    <div className="flex gap-6 mt-1 justify-center mb-5 ">
                        <div>
                            <label  className="flex items-center mr-2">
                                <input type="radio"  className="peer hidden" />
                               非常不符合 <div className={`w-10 h-10 ml-2 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#e76f51] bg-[#e76f51]`}></div>
                            </label>
                            {/* <p  className="mt-1"></p> */}
                        </div>
                        <div>
                            <label  className="flex items-center mr-2">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#f4a261] bg-[#f4a261] `}></div>
                            </label>
                            <p className="mt-1"> </p>
                        </div>
                        <div>
                            <label  className="flex items-center mr-2">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#e9c46a] bg-[#e9c46a]`}></div>
                            </label>
                            <p className="mt-1"> </p>
                        </div>
                          <div>
                            <label  className="flex items-center mr-2">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#c9ada7] bg-[#c9ada7] `}></div>
                            </label>
                            <p className="mt-1"> </p>
                        </div>
                        <div>
                            <label  className="flex items-center mr-2">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#95d5b2] bg-[#95d5b2] `}></div>
                            </label>
                            <p className="mt-1"> </p>
                        </div>
                        <div>
                            <label  className="flex items-center mr-2">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#52b788] bg-[#52b788]`}></div>
                            </label>
                            <p className="mt-1"> </p>
                        </div>
                        <div>
                            <label  className="flex items-center mr-2">
                                <input type="radio"  className="peer hidden" />
                                <div className={`w-10 h-10 mr-2 rounded-full flex border items-center justify-center transition transform hover:scale-105 border-2 border-[#2a9d8f] bg-[#2a9d8f]`}></div> 
                                非常符合
                            </label>
                            {/* <p className="mt-1"> </p> */}
                        </div>
                    </div>
                    

                    <div  className="mb-2 flex"> 
                        <svg className="w-6 h-6 text-blue-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 3.464V1.1m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C17 15.4 17 16 16.462 16H3.538C3 16 3 15.4 3 14.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 10 3.464ZM4 3 3 2M2 7H1m15-4 1-1m1 5h1M6.54 16a3.48 3.48 0 0 0 6.92 0H6.54Z"/>
                        </svg>
                        <p className="mb-2 ml-2 flex text-blue-400">做你自己，並誠實回答問題。您的私隱非常安全，不會外洩。</p>
                    </div>
                    <form
                        className="space-y-6"
                        onSubmit={(e) => {
                            e.preventDefault();
                            if (answers.length === questions.length && answers.every((value) => !!value.answer)) {
                                submitSurvey({
                                    userId: getCurrentUser()!.id,
                                    userType: getCurrentUser()!.role === UserInfoResponseRole.STUDENT ? 1 : 2,
                                    surveyId: 4,
                                    startTime: startTime!.toISOString(),
                                    submitTime: (new Date()).toISOString(),
                                    items: answers
                                }).then(rsp => {
                                    if (rsp.code === 200 && onSuccess) {
                                        onSuccess();
                                    }
                                }).catch(error => {

                                });
                            } else {
                                toast.error(t('component.needanswer'));
                            }
                            return false;
                        }}
                    >

                        {questions.map((q, index) => (
                            <div key={q.id} className="bg-white rounded-lg shadow p-4 mb-4">
                                <label className="block font-medium text-m text-black">
                                    {q.text} <span className="text-red-500">*</span>
                                </label>

                                <div className="flex gap-6 mt-1 justify-center ">
                            
                    
                                 
                                    {[1, 2, 3, 4, 5, 6,7].map((val, optionIndex) => {
                                        const colors = [
                                            "border-2 border-[#e76f51] peer-checked:bg-[#e76f51] peer-checked:text-white",
                                            "border-2 border-[#f4a261] peer-checked:bg-[#f4a261] peer-checked:text-white",
                                            "border-2 border-[#e9c46a] peer-checked:bg-[#e9c46a] peer-checked:text-white",
                                            "border-2 border-[#c9ada7] peer-checked:bg-[#c9ada7] peer-checked:text-white",
                                            "border-2 border-[#95d5b2] peer-checked:bg-[#95d5b2] peer-checked:text-white",
                                            "border-2 border-[#52b788] peer-checked:bg-[#52b788] peer-checked:text-white",                                            
                                            "border-2 border-[#2a9d8f] peer-checked:bg-[#2a9d8f]  peer-checked:text-white"
                                        ];
                                        return (
                                            <label key={val} className="flex items-center mr-2">
                                                <input
                                                    type="radio"
                                                    name={`q${q.id}`}
                                                    value={val}
                                                    className="peer hidden"
                                                    required
                                                    onChange={(e) => {
                                                        answers[index] = {
                                                            questionId: q.id,
                                                            answer: e.target.value,
                                                            answerAt: new Date().toISOString(),
                                                        };
                                                    }}
                                                />
                                           
                                                <div className={` w-10 h-10 rounded-full flex items-center justify-center border transition-transform hover:scale-105 ${colors[optionIndex]}
                                                    peer-checked:[&>svg]:opacity-100 peer-checked:[&>svg]:scale-100
                                                    `} >
                                                    <svg className="w-8 h-8 opacity-0 scale-95 transition-transform"  fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                                        
                                             
                                                     
                                                
                                            </label>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}

                        <div className="text-center mt-8">
                            <button type="submit" className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                                提交問卷
                            </button>
                        </div>
                    </form>
                </div>
            </div>
    )
}

export default withTranslation()(Survey4);